module.exports = __webpack_public_path__ + "static/media/199-sudan.492f6ceb.svg";